import {
  createContext,
  ReactElement,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from 'react';

interface PageSettingsValue {
  disableFooter: boolean;
  metaTitle?: string;
  headerTitle?: string;
  headerSubtitle?: string;
  headerElevation?: boolean;
  headerExtraContent?: ReactElement;
}

interface PageSettingsContextValue {
  value: PageSettingsValue;
  setValue:(newValue: PageSettingsValue) => void;
}

const defaultValue: PageSettingsValue = {
  disableFooter: false,
  headerElevation: true,
};

const PageSettingsContext = createContext<PageSettingsContextValue>({
  value: defaultValue,
  setValue: () => undefined,
});

export function PageSettingsContextProvider({
  children,
}: { children?: ReactNode }) {
  const [value, setValue] = useState<PageSettingsValue>(defaultValue);

  useEffect(() => {
    const titleBase = 'Intoto';
    document.title = value.metaTitle ? `${value.metaTitle} - ${titleBase}` : titleBase;
  }, [value.metaTitle]);

  const contextValue = useMemo(() => ({
    value,
    setValue,
  }), [value]);

  return (
    <PageSettingsContext.Provider value={contextValue}>
      {children}
    </PageSettingsContext.Provider>
  );
}

export default PageSettingsContext;
